import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import { getDataFromAPI } from '../HandleAPICalls/actions';
import {
  setFormLoading,
  setFormDataToStore,
  setManufacturerId,
  setMRP,
  setOfferPrice,
  setVariantId,
  setVendorPrice,
  setSubmitLoading
} from './actions';
import {parseOptionsWithUpdatedDate} from '../../utils/parseResponseToOptions.jsx';
import CreateManufacturerVariantComponent from './component';

class CreateMVContainer extends Component {
  componentDidMount() {
    this.props.setFormLoading(true);
    this.props.getDataFromAPI(
      '/form/mv/dropdowns',
      'GET',
      undefined,
      response => {
        console.log(response);
        this.props.setFormDataToStore(response);
        this.props.setFormLoading(false);
      },
      err => {
        console.log(err);
        toastr.error('Failed', 'Unable to fetch manufacturer details');
        this.props.setFormLoading(true);
      }
    );
  }

  // fields handler
  onChangeOfMrp = event => {
    this.props.setMRP(event.target.value);
  };

  onChangeOfOfferPrice = event => {
    this.props.setOfferPrice(event.target.value);
  };

  onChangeOfVendorPrice = event => {
    this.props.setVendorPrice(event.target.value);
  };

  onChangeOfManufacturerId = (event, data) => {
    this.props.setManufacturerId(data.value);
  };

  onChangeOfVariantId = (event, data) => {
    this.props.setVariantId(data.value);
  };

  handleSubmit = () => {
    this.props.setSubmitLoading(true);
    const { manufacturerId, variantId, offerPrice, mrp, vendorPrice } = this.props.createMV;

    const payload = {
      manufacturerId,
      variantId,
      offerPrice,
      mrp,
      vendorPrice
    };

    this.props.getDataFromAPI(
      '/mvs/new',
      'POST',
      payload,
      response => {
        toastr.success('Successful', 'Added New Variant');
        this.props.setSubmitLoading(false);
        return this.props.history.push('/products');
      },
      err => {
        this.props.setSubmitLoading(false);
      }
    );
  };

  render() {
    const formData = this.props.createMV && this.props.createMV.formData;
    const submitLoading = this.props.createMV && this.props.createMV.submitLoading;

    return (
      <CreateManufacturerVariantComponent
        loading={this.props.createMV && this.props.createMV.loading}
        manufacturersDD={parseOptionsWithUpdatedDate(formData.manufacturers)}
        variantsDD={parseOptionsWithUpdatedDate(formData.variants)}
        onChangeOfMrp={this.onChangeOfMrp}
        onChangeOfOfferPrice={this.onChangeOfOfferPrice}
        onChangeOfVendorPrice={this.onChangeOfVendorPrice}
        onChangeOfManufacturerId={this.onChangeOfManufacturerId}
        onChangeOfVariantId={this.onChangeOfVariantId}
        submitLoading={submitLoading}
        handleSubmit={this.handleSubmit}
      />
    );
  }
}

function mapStateToProps({ createMV }) {
  return {
    createMV
  };
}

export default withRouter(
  connect(mapStateToProps, {
    setFormLoading,
    setFormDataToStore,
    setManufacturerId,
    setMRP,
    setOfferPrice,
    setVariantId,
    setVendorPrice,
    setSubmitLoading,
    getDataFromAPI
  })(CreateMVContainer)
);



// WEBPACK FOOTER //
// ./src/Modules/CreateNewManufacturerVariant/container.jsx